export default __webpack_public_path__ + "21b2b8624f3ab40fe997afb4fd40d6f8.png";